module.exports = __webpack_public_path__ + "fonts/SEBSansSerif-Bold.21610dc7.woff2";